<div class="container">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 tot-pad">
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 selectDeliverMethod">
        <img src="../../../../assets/icons/Info Circle.png" class="cursor" alt=""
          (click)="closeModalDeliveryMethod()" />
      </div>

      <div class="addeve-sty">Select delivery method</div>

      <div class="del-body-col" *ngIf="selectRestaurantData?.delivery">
        <div>
          <div class="first-card">
            <div class="delivery_img_content">
              <div class="back-img">
                <img src="../../../../assets/icons/truck-delivery.png">
              </div>
              <span class="del-btn">Delivery</span>
            </div>

            <form class="checkForm" [formGroup]="checkForm">
              <div class="checkForm_1">
                <p></p>
                <!-- <input type="checkbox" [(ngModel)]="deliveryCheckboxSelected" (change)="onDeliveryCheckboxChange()"
                  formControlName="checkbox"> -->
                <!-- <mat-radio-button class="status" checked="false" formControlName="checkbox"
                  [(ngModel)]="deliveryCheckboxSelected" (change)="onDeliveryCheckboxChange()"></mat-radio-button> -->
                  
                  <!-- <input type="checkbox"  class="status delivery-checkbox" [checked]="deliveryCheckboxSelected" (change)="onDeliveryCheckboxChange($event)">          -->

                  <div class="check_box_styl_1 d-flex align-items-center">
                    <mat-checkbox class="example-margin" [checked]="deliveryCheckboxSelected" (change)="onDeliveryCheckboxChange($event)"></mat-checkbox>
                  </div>

              </div>
            </form>
          </div>
        </div>
      </div>


      <div class="del-body-col" style=" margin-bottom: 30px;"  *ngIf="selectRestaurantData?.pickup">
        <div>
          <div class="second-card">
            <div class="checkForm">
              <div class="back-img">
                <img src="../../../../assets/icons/paper-bag.png">
              </div>
              <span class="del-btn">Pick-up</span>
            </div>

            <form class="checkForm" [formGroup]="checkForm">
              <div class="checkForm">
                <p></p>
                <!-- <input type="checkbox" [(ngModel)]="pickupCheckboxSelected" (change)="onPickupCheckboxChange()"
                  formControlName="checkbox"> -->
                <!-- <mat-radio-button class="status" checked="false" formControlName="checkbox"
                  [(ngModel)]="pickupCheckboxSelected" (change)="onPickupCheckboxChange()"></mat-radio-button> -->
                  <!-- <input type="checkbox" class="status pickup-checkbox" [checked]="pickupCheckboxSelected" (change)="onPickupCheckboxChange($event)"> -->
                  <div class="check_box_styl_1 d-flex align-items-center">
                    <mat-checkbox class="example-margin" [checked]="pickupCheckboxSelected" (change)="onPickupCheckboxChange($event)"></mat-checkbox>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">

        <button mat-raised-button color="warn" class="nex-btn" [disabled]="!delieveryCheckBoxText && !pickupCheckboxSelected"
          (click)="onclickAddEvent()">Add Event</button>
      </div>
    </div>
</div>